import React from 'react';
import { Card, CardContent, CardActions, Typography, Button, Box } from '@mui/material';

interface ProductCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  features: string[];
}

export const ProductCard: React.FC<ProductCardProps> = ({
  title,
  description,
  icon,
  features
}) => {
  return (
    <Card 
      elevation={0}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'transform 0.2s',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 2
        }
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          {icon}
          <Typography variant="h5" component="h2" sx={{ ml: 1 }}>
            {title}
          </Typography>
        </Box>
        <Typography color="text.secondary" paragraph>
          {description}
        </Typography>
        <ul>
          {features.map((feature, index) => (
            <Typography
              key={index}
              component="li"
              color="text.secondary"
              sx={{ mb: 1 }}
            >
              {feature}
            </Typography>
          ))}
        </ul>
      </CardContent>
      <CardActions>
        <Button size="large" color="primary">
          Learn More
        </Button>
        <Button size="large" variant="contained" color="primary">
          Try Now
        </Button>
      </CardActions>
    </Card>
  );
};
